import {Custodian} from '@principal/types/src/custodians/custodians';
import {getCustodianMetadata} from '@principal/types/src/custodians/custodian-type';

export default class Store {
  constructor() {
    this.showNavigation = null;
    this.headerType = null;
    this.footerType = null;
    this.isLoading = null;
    this.isLayoutSet = null;
    this.favicon = null;
    this.riaId = null;
    this.riaName = null;
    this.enterpriseId = null;
    this.redirectPath = null;
    this.custodians = getCustodianMetadata(Custodian.Apex);
  }
}
